import { rem } from '@innovyze/stylovyze';
import { Paper, Typography } from '@mui/material';
import styled from 'styled-components';

export const StyledPaper = styled(Paper)`
	margin-top: ${rem(20)};
	padding: ${rem(16)} ${rem(24)} ${rem(25)} ${rem(24)};
`;

export const StyledForm = styled.form`
	margin-top: ${rem(8)};
`;

export const StyledHeader = styled.div`
	margin-top: ${rem(32)};
`;

export const StyledTitle = styled(Typography)`
	font-weight: 600;
	font-size: 18px;
	line-height: 24px;
	color: #272833;
`;

export const StyledCaption = styled(Typography)`
	font-size: 12px;
	line-height: 16px;
	color: #768d95;
	margin-bottom: ${rem(10)};
`;
